import { useCallback, useState } from 'react';

import LobbyPage from './pages/LobbyPage';
import MeetingPage from './pages/MeetingPage';
import EndCallPage from './pages/EndCallPage';
import { Permissions } from './types';


enum CurrentAppPage {
  LOBBY,
  MEETING,
  END_CALL,
}

export default function AppContainer() {
  const [appPage, setAppPage] = useState<CurrentAppPage>(CurrentAppPage.LOBBY);
  const [permissions, setPermissions] = useState<Permissions>({ audio: false, video: false });

  const onJoin = useCallback((newPermissions: Permissions) => {
    setAppPage(CurrentAppPage.MEETING);
    setPermissions(newPermissions);
  }, []);

  // A call the user ended and one that ended itself look the same from here, but
  // not to the person reading the screen: one of them may well want back in.
  const [wasAbandoned, setWasAbandoned] = useState(false);

  const onEndCall = useCallback(() => {
    setAppPage(CurrentAppPage.END_CALL);
  }, []);

  const onAbandoned = useCallback(() => {
    setWasAbandoned(true);
    setAppPage(CurrentAppPage.END_CALL);
  }, []);

  if (appPage === CurrentAppPage.LOBBY) {
    return <LobbyPage onJoin={onJoin} />;
  } else if (appPage === CurrentAppPage.MEETING) {
    return (
      <MeetingPage
        onAbandoned={onAbandoned}
        onEndCall={onEndCall}
        permissions={permissions}
      />
    );
  } else if (appPage === CurrentAppPage.END_CALL) {
    return <EndCallPage wasAbandoned={wasAbandoned} />;
  }

  const unsupportedPage: never = appPage;
  throw new Error(`We don't support this page yet ${unsupportedPage}`);
}
